<template>
	<section>
		<router-link class="blog" v-for="(blog, index) in blogs" tag="div" :key="index" :to="`/blog/${blog.id}`" v-if="blogs.length > 0">
			<h2 class="blog__title" v-html="blog.title.rendered"></h2>
			<p class="blog__date">
				{{ blog.date | moment('Do MMMM YYYY') }}
			</p>
			<p class="blog__excerpt" v-html="blog.excerpt.rendered"></p>
		</router-link>
	</section>
</template>

<script>
export default {
	name: 'BlogList',
	data() {
		return {
			buttonMessage: 'Click me!',
			blogs: [],
		};
	},
	created() {
		this.$store.dispatch('getBlogs').then(() => {
			this.blogs = this.$store.state.blogs;
		});
	},
};
</script>

<style scoped lang="scss">
.blog {
	animation: fadeIn 0.3s forwards;
	cursor: pointer;
	margin-bottom: 2em;
	opacity: 0;
	padding: 1em;
	position: relative;
	transition: 0.2s all;

	@for $i from 2 through 10 {
		&:nth-of-type(#{$i}) {
			animation-delay: ($i - 1) * 0.05s;
		}
	}

	&:hover {
		color: $primary;
	}

	&:not(:last-of-type)::after {
		border-bottom: 1px dashed #ddd;
		bottom: -1em;
		content: '';
		left: 50%;
		position: absolute;
		transform: translateX(-50%);
		width: 50%;
	}

	&__title {
		margin-bottom: 0;
		text-align: left;
	}

	&__date {
		color: #aaa;
		margin-top: 0;
	}
}
@keyframes fadeIn {
	0% {
		opacity: 0;
		transform: translateY(20px);
	}
	100% {
		opacity: 1;
		transform: translateY(0);
	}
}
</style>
